import InputWrapper from "./components/InputWrapper";
import { Link, useLocation } from "react-router-dom";
import GoBack from "./components/GoBack";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Repository from "../../repository";
import { useState } from "react";
import Meta from "../components/Meta";
import { loginSchema } from '../../validation/schemas';

const Login = () => {
    const location = useLocation();
    const referer = location.search.split("?referer=")[1]

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(loginSchema),
        defaultValues: {
            email: '',
            password: ''
        }
    })

    const submit = async (data) => {
        setLoading(true)

        try {
            const result = await Repository.login(data.email, data.password)
            localStorage.setItem("token", result.data.token);
            window.location.href = referer ? referer : '/';

            setLoading(false)
            setError(false)
        } catch (error) {
            setLoading(false)
            setError(true)
        }
    }

    return (
        <>
            <Meta title={'Login'} />
            <GoBack to={"/"} label={"Back to Home"} />
            <form className={"w-96 mx-auto py-40 px-4 grid grid-cols-1 gap-4 rounded-lg"} onSubmit={handleSubmit(submit)}>
                <h1>Login</h1>
                <InputWrapper label={"Email Address"} input={<input type={"text"} {...register("email")} />} error={errors.email?.message} />
                <InputWrapper label={"Password"} input={<input type={"password"} {...register("password")} />} error={errors.password?.message} />
                <button type={"submit"} disabled={loading}
                    className={"inline-block bg-primary py-2 px-4 w-full lg:w-auto text-white text-center rounded-md mt-2 border-0"}>{loading ? '...' : 'Login'}</button>
                {error && <p className={"text-red-500"}>Invalid email or password</p>}
                <Link className={"text-sm text-textGrey"} to={'/forgot-password'}>Forgot Password?</Link>
                <Link className={"text-sm text-textGrey"} to={`/create-account${location.search}`}>Don't have an account? Create Account</Link>
            </form>
        </>
    )
}

export default Login
